import {SellerError} from './SellerError.js'

export class InvalidEmailSellerError extends SellerError {}
